import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=4a2a084b&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=4a2a084b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2a084b",
  null
  
)

export default component.exports